// src/i18n.js
import VueI18n from 'vue-i18n';
import Vue from 'vue';


Vue.use(VueI18n);

const messages = {
  en: {
    new_entry: 'New entry',
    processing_activity: 'Record of processing activities',
    name: 'Name',
    purpose_data_processing: 'Purpose of data processing',
    description: 'Description',
    departments: 'Departments',
    tasks: 'Tasks',
    task: 'Task',
    process_type: 'Type of processing and safety precautions',
    supplier: 'Supplier',
    system: 'System',
    systems: 'Systems',
    affected_person: 'Data subjects',
    data_type: 'Personal data collected',
    data_origin: 'Data origin',
    person_informed: 'Data subjects informed',
    data_type_category: 'Types of personal data',
    number_of_persons: 'Number of data subjects',
    risk_level: 'Risk level',
    process_place: 'Locations/department of activity',
    access_rights: 'Access and rights',
    storage_duration: 'Actual storage duration / deletion periods / retention period',
    data_storage: 'Retention period/deletion deadline',
    storage_should: 'Prescribed / statutory retention period',
    reason_extended_storage: 'Reason for extended retention',
    delete_method: 'How is data deletion/destruction carried out?',
    delete_department: 'Executing department',
    delete_process: 'Are there processes in place for carrying out deletion and data destruction?',
    storage_legal_base: 'Legal basis for retention',
    legitimate_interest: 'Legitimate interest and necessity',
    legal_base_requirement: 'Statutory requirement',
    affected_interests: 'Affected interests of the data subjects',
    interest_balance: 'Weighing of interests; outcome of the balancing of interests',
    intern_receipt: 'Internal receiver',
    extern_receipt: 'External receiver',
    data_transfer: 'Data transfer to third countries',
    profiling: 'Evaluation of personality/profiling',
    evaluation: 'Evaluation',
    document: 'Name of the documents',
    storage_place: 'Storage location',
    modified: 'Updated on',
    risk_remarks: 'Remarks for risk assessment',
    risk_level_remarks: 'Remark on the risk level',
    person_informed_remarks: 'Remarks for data subjects',
    legal_base_remarks: 'Remark for legal basis',
    data_transfer_remarks: 'Remark for data transmission',
    profiling_remarks: 'Remark for evaluation of personality/profiling',
    evaluation_remarks: 'Remark for evaluation',
    assessment_necessary: 'Data protection impact assessment required',
    complete_risk_assessment: 'Conduct a complete risk assessment',
    simple_risk_assessment: 'Conduct a simple risk assessment',
    legal_base: {
      name: 'Legal basis',
      option1: 'Fulfillment of a legal obligation (Art. 6 para. 1 lit. c GDPR)',
      option2: 'Contract or contract initiation (Art. 6 para. 1 lit. b GDPR)',
      option3: 'Safeguarding the legitimate interests of the controller or a third party (Art. 6 para. 1 lit. f)',
      option4: 'Consent (Art. 6 para. 1 lit. a, Art. 7)',
      option5: 'Company or individual agreement',
      option6: 'Protection of vital interests of the person concerned',
      option7: 'Safeguarding public interests or exercising official authority',
      option8: 'Consent of a child (Art. 6 para. 1 lit. a, Art. 8)',
      option9: 'Others',
    },
    menu: {
      counselor: 'Counselor',
      overview: 'Overview',
      gap_analysis: 'GDPR Gap analysis',
      ai_gap_analysis: 'AI Act Gap analysis',
      actions: 'Actions',
      action_plan: 'Action plan',
      ai_action_plan: 'AI Act Action plan',
      action_plan_calendar: 'Action plan calendar',
      vt: 'RoPA',
      risk_assessment: 'Risk assessment',
      vt_processor: 'RoPA(data processor)',
      shared_responsibility: 'Joint controllership',
      systems: 'Systems',
      system_assessment: 'System assessment',
      supplier: 'Supplier',
      incidents: 'Incidents',
      review: 'Review/Audit',
      dpa_check: 'DPA Check',
      listing: 'Listing',
      edit_survey: 'Edit questionnaire',
      toms: 'TOMs',
      ds_report: 'Create DP report',
      translate: 'Translate',
      to_crm: 'Link to CRM',
      risk: 'Risk',
      lenz_tech: 'Lenz-tech',
      website_audit: 'Website Audit',
      start_website_audit: 'Create Audit',
      audits_listing: 'All Audits',
    },
    task_status: {
      completed: 'Completed',
      not_applicable: 'Not applicable',
      open: 'Open',
      in_progress: 'In progress',
      canceled: 'Canceled',
      duplicate: 'Duplicate',
      other: 'Other',
    },
    risk_level_option: {
      normal: 'Normal',
      high: 'High',
      very_high: 'Very High',
    },
    data_controller: 'Controller',
    process_name: 'Name of processing activity',
    stand: 'Current state',
    tom: 'TOMs',
    comments: 'Comments',
    checked_on: 'Checked on',
    department: 'Department',
    other_responsible: 'Other responsibilities',
    authentication: 'Access rights',
    deletion: 'Delete concept',
    backup: 'Backup',
    remarks: 'Remarks',
    processor: 'Processor',
    place: 'Location of the receiving office',
    responsible_units: 'Responsible organizational unit',
    contract_w_date: 'Contract - valid until',
    checked: 'Audit took place',
    subcontractor: 'Subcontractors available',
    subcontractor_checked: 'Subcontractor approved',
    how: 'How are the personal data processed?',
    informer: 'Who assumes the rights of data subjects?',
    deleter: 'Who ensures the deletion?',
    responser: 'Who is responsible for reporting data breaches?',
    all_entries: 'All entries',
    relevant_entries: 'relevant entries',
    irrelevant_entries: 'irrelevante Einträge',
    old_number: 'old number',
    new_number: 'new number',
    ai_number: 'internal number',
    questionnaire: 'Questionnaire',
    gdpr_requirement: 'Requirement from GDPR',
    ai_requirement: 'Requirement from AI Act',
    actual_status: 'Actual status',
    required_field: 'required field',
    communicated_by: 'communicated by',
    last_status: 'Last status',
    documents: 'documents',
    help_text: 'Explanation support',
    gdpr_reference: 'GDPR reference',
    text_block: 'Text block',
    template_link: 'Link to the template',
    yes: 'Yes',
    no: 'No',
    others: 'Others',
    create_task: 'Create action',
    save: 'Save',
    close: 'Close',
    canceled: 'Cancel',
    save_success_msg: 'is successfully saved!',
    display_column: 'Display column',
    client_overview: 'Client Overview',
    with_percentage: 'with percentages',
    finished: 'Finished',
    in_progress: 'In progress',
    no_entry: 'No entry',
    task_in_the_year: 'Task in the year',
    topics: 'Topics',
    added: 'Datum',
    origin: 'Origin',
    section: 'Section/row',
    deadline: 'implement until / target',
    steps: 'Steps',
    responsible_person: 'Responsible person',
    new_task: 'New task',
    all: 'All',
    entries: 'entries',
    open_tasks: 'open tasks',
    processing_tasks: 'tasks in process',
    completed_tasks: 'tasks completed',
    listing: 'Listing',
    calendar_view: 'Calendar view',
    ds_report_info: 'DP report information',
    time_period: 'Time period',
    authors: 'Authors',
    template: 'Template',
    addressed_to: 'addressed to',
    management: 'Management',
    executive_board: 'Executive Board',
    reporting_year: 'Reporting year',
    generate: 'Generate',
    ds_report: 'Data protection report',
    creation_date: 'Creation date',
    incident_acknowledgement: 'Date and time of acknowledgement',
    reporting_party: 'Reporting party / Who detected the fault',
    incident_description: 'Description of the security incident / data breach',
    incident_consequences: 'Possible consequences for those affected',
    authority_notification: 'Notification to the supervisory authority',
    authority_notified: 'Reported to the supervisory authority',
    not_authority_notified: 'Not reported to the supervisory authority',
    notification_date: 'Notification to the supervisory authority on',
    data_subject_information: 'Information for data subject',
    data_subject_informed: 'Data subjects informed',
    data_subject_not_informed: 'Data subjects were not informed',
    data_subject_informed_how: 'How and when were data subjects informed',
    incident_action_plan: 'Measures derived / actions carried out',
    process_controller: 'Process controller',
    report: 'Report',
    start_date: 'Start date',
    end_date: 'End date',
    report_date: 'Report date',
    gap_status_entry: 'Enter actual status',
    new: 'new',
    priority: 'Priority',
    created_on: 'Created on',
    status: 'Status',
    complete_missing_fields: 'Please complete the missing fields!',
    saved_successfully: 'is successfully saved!',
    deleted_successfully: 'is successfully deleted!',
    gap_question: 'GAP Question',
    used: 'Used',
    contract: 'Contract',
    chargeable: 'Chargeable',
    amount: 'Amount',
    staff: 'Staff',
    effort: 'Effort',
    confirm_delete_step: 'Are you sure to delete this step?',
    confirm_delete_work: 'Are you sure to delete this effort/expense?',
    confirm_effort_to_task: 'Should an effort be converted to a completed task?',
    confirm_deadline_to_today: 'Should the deadline be today?',
    edit: 'edit',
    show_more: 'show more',
    cancel: 'Cancel',
    abbreviations: 'Abbreviations',
    switch_client: 'Switch client',
    general: 'General',
    data_subject: 'Data subject',
    collected_pd: 'Collected personal data',
    other_properties: 'Other properties',
    controller: 'Controller',
    av_audit_completed: 'AV audit completed',
    subcontractors_exist: 'Subcontractors exist',
    short_description: 'Short description',
    responsible_department: 'Responsible department',
    purpose: 'Purpose',
    receiving_party: 'Receiving party',
    type_of_data: 'Type of data',
    audit_report: 'Audit report',
    ds_assessment: 'Data protection assessment',
    valid_days: 'Valid period',
    valid_date: 'Expiry data',
    days: 'Days',
    dpo_assessment: 'Summary of the assessment (DPO)',
    dpo_assessment_template: '<p class="ql-align-justify"><em style="background-color: yellow; color: rgb(89, 89, 89);">Necessary principles in place: </em></p><p class="ql-align-justify"><span style="background-color: yellow; color: rgb(89, 89, 89);">-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><em style="background-color: yellow; color: rgb(89, 89, 89);">Organization: Data Privacy Management in place (Compliance including various policies)</em></p><p class="ql-align-justify"><span style="background-color: yellow; color: rgb(89, 89, 89);">-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><em style="background-color: yellow; color: rgb(89, 89, 89);">Purpose, legal basis: defined and applicable. </em></p><p class="ql-align-justify"><span style="background-color: yellow; color: rgb(89, 89, 89);">-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><em style="background-color: yellow; color: rgb(89, 89, 89);">Technical and organizational measures: in place. </em></p><p class="ql-align-justify"><span style="background-color: yellow; color: rgb(89, 89, 89);">-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><em style="background-color: yellow; color: rgb(89, 89, 89);">Awareness training for persons processing the data: on a regular basis. </em></p><p class="ql-align-justify"><span style="background-color: yellow; color: rgb(89, 89, 89);">-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><em style="background-color: yellow; color: rgb(89, 89, 89);">Data Transfer Agreement (including Standard Contractual Clauses since data will be transferred to the US): in place</em></p><p class="ql-align-justify"><span style="background-color: yellow; color: rgb(89, 89, 89);">-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><em style="background-color: yellow; color: rgb(89, 89, 89);">Right and Role concept: necessary data due to need to know</em></p><p class="ql-align-justify"><span style="background-color: yellow; color: rgb(89, 89, 89);">-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><em style="background-color: yellow; color: rgb(89, 89, 89);">Data Minimization: only necessary data-fields (purpose) in place.&nbsp;</em></p><p class="ql-align-justify"><span style="background-color: yellow; color: rgb(89, 89, 89);">-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><em style="background-color: yellow; color: rgb(89, 89, 89);">Analysis or Profiling: only overview of the data, no Profiling </em></p><p class="ql-align-justify"><span style="background-color: yellow; color: rgb(89, 89, 89);">-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><em style="background-color: yellow; color: rgb(89, 89, 89);">Rights of the Data Subjects: met, including information of the data subjects before data is being processed. </em></p><p class="ql-align-justify"><span style="background-color: yellow; color: rgb(89, 89, 89);">-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><em style="background-color: yellow; color: rgb(89, 89, 89);">Data Retention Schedule: in place. </em></p><p class="ql-align-justify"><span style="background-color: yellow; color: rgb(89, 89, 89);">-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><em style="background-color: yellow; color: rgb(89, 89, 89);">Risk assessment from project owner: No high risk for data subjects. </em></p><p class="ql-align-justify"><em style="background-color: yellow; color: rgb(89, 89, 89);">&nbsp;</em></p><p class="ql-align-justify"><em style="background-color: yellow; color: rgb(89, 89, 89);">Based on the information (as above) and the referred documents the processing of the personal data follows the Principles relating to processing of personal data as defined in the GDPR. </em></p><p class="ql-align-justify"><em style="background-color: yellow; color: rgb(89, 89, 89);">I do not see high risks for the data subjects and therefore I approve the implementation/the change of the system / process XXXX in XXXX at this time. </em></p>',
    assessed_by: 'Assessment performed by (Name and position))',
    language: 'Language',
    german: 'German',
    english: 'English',
    greeting: 'Greeting',
    mr: 'Mr.',
    ms: 'Ms.',
    hello: 'none/Dear',
    recipient: 'Recipient',
    duplicate: 'duplicate',
    approved: 'approved',
    simple_risk_analysis: 'Simple risk analysis',
    gap_entry: 'GAP entry',
    todo_entry: 'Create task',
    filled_by: 'filled out by',
    audited_by: 'audited by',
    password: 'Password',
    chat_history: 'Chat History',
    new_chat: 'New Chat',
    you: 'Du',
    today: 'Today',
    create_system: 'Create System after release',
    ki_used: 'AI Integration',
    dsfa_required: 'DSFA required',
    ki_not_checked: 'AI integrated, but not assessed',
    ki_checked: 'AI integrated, and assessed',
    released: 'Released',
    processing: 'In process',
    na: 'N/A',
    not_used: 'not used',
    ai: 'AI',
    mandant_name: 'Client',
    created_at: 'Created on',
    auditor_name: 'Auditor',
    full_report: 'Full Report',
    ai_report: 'AI Report',
    dsfa_report: 'DPIA Report',
    todo_list: 'Todo List',
  },
  de: {
    new_entry: 'Neuer Eintrag',
    processing_activity: 'Verarbeitungstätigkeit',
    name: 'Name',
    purpose_data_processing: 'Zweck der Datenverarbeitung',
    description: 'Beschreibung',
    departments: 'Abteilungen',
    tasks: 'Maßnahmen',
    process_type: 'Art der Verarbeitung und Sicherheitsvorkehrungen',
    supplier: 'Dienstleister',
    system: 'System',
    systems: 'Systeme',
    affected_person: 'Data subjects',
    data_type: 'erfasste pb. Daten',
    data_origin: 'Datenherkunft',
    person_informed: 'Betroffene informiert',
    data_type_category: 'Arten von personenbezogenen Daten',
    number_of_persons: 'Anzahl der betroffenen Personen',
    risk_level: 'Risikostufe',
    process_place: 'Standorte/Abteilung der Tätigkeit',
    access_rights: 'Zugriff und Rechte',
    storage_duration: 'Tatsächlich Speicherdauer/Löschfristen/Aufbewahrungsfrist',
    data_storage: 'Speicherdauer/Löschfrist',
    storage_should: 'vorgeschriebene / gesetzliche Aufbewahrungsdauer',
    reason_extended_storage: 'Grund der längeren Aufbewahrung',
    delete_method: 'Wie wird die Datenlöschung/- vernichtung durchgeführt',
    delete_department: 'Durchführende Abteilung',
    delete_process: 'Sind Prozesse für die Durchführung der Löschung- und Datenvernichtung vorhanden?',
    storage_legal_base: 'Rechtsgrundlage der Aufbewahrung',
    legitimate_interest: 'Berechtigtes Interesse und Erforderlichkeit',
    legal_base_requirement: 'Gesetzliche Vorgabe',
    affected_interests: 'Berührte Interessen der Betroffenen',
    interest_balance: 'Abwägung; Ergebnis der Interessenabwägung',
    intern_receipt: 'Interner Empfänger',
    extern_receipt: 'Externer Empfänger',
    data_transfer: 'Datenübermittlung in Drittstaaten',
    profiling: 'Bewertung von Persönlichkeit/Profiling',
    evaluation: 'Auswertung',
    document: 'Name der Dokumenten',
    storage_place: 'Speicherort',
    modified: 'Aktualisiert am',
    risk_remarks: 'Bemerkungen für Risiko Bewertung',
    risk_level_remarks: 'Bemerkung zur Risikostufe',
    person_informed_remarks: 'Bemerkungen für Betroffene Personen',
    legal_base_remarks: 'Bemerkung für Rechtsgrundlage',
    data_transfer_remarks: 'Bemerkung der Datenübermittlung',
    profiling_remarks: 'Bemerkungen für Bewertung von Persönlichkeit/Profiling',
    evaluation_remarks: 'Bemerkungen für Auswertungen',
    assessment_necessary: 'Datenschutzfolgeabschätzung erforderlich',
    complete_risk_assessment: 'Komplette Risikobewertung durchführen',
    simple_risk_assessment: 'Einfache Risikobewertung durchführen',
    legal_base: {
      name: 'Rechtsgrundlage',
      option1: 'Erfüllung einer rechtlichen Verpflichtung (Art. 6 Abs. 1 lit. c DSGVO)',
      option2: 'Vertrag oder Vertragsanbahnung (Art. 6 Abs. 1 lit. b DSGVO)',
      option3: 'Wahrung berechtigter Interessen des Verantwortlichen oder eines Dritten (Art. 6 Abs. 1 lit. f)',
      option4: 'Einwilligung (Art. 6 Abs. 1 lit. a, Art. 7)',
      option5: 'Betriebs- oder Einzelvereinbarung',
      option6: 'Schutz lebenswichtiger Interessen des Betroffenen',
      option7: 'Wahrung öffentlicher Interessen oder Ausübung öffentlicher Gewalt',
      option8: 'Einwilligung eines Kindes (Art. 6 Abs. 1 lit. a, Art. 8)',
      option9: 'Sonstiges',
    },
    risk_level_option: {
      normal: 'Normal',
      high: 'Hoch',
      very_high: 'Sehr Hoch',
    },
    menu: {
      counselor: 'Betreuer',
      overview: 'Übersicht',
      gap_analysis: 'DS Gap Analyse',
      ai_gap_analysis: 'KI Gap Analyse',
      actions: 'Maßnahmen',
      action_plan: 'DS Maßnahmenplan',
      ai_action_plan: 'KI Maßnahmenplan',
      action_plan_calendar: 'Maßnahmenplan Kalendar',
      vt: 'VT',
      risk_assessment: 'Risikobewertung',
      vt_processor: 'VT(selbst Datenverarbeiter)',
      shared_responsibility: 'Gemeinsame Verantwortung',
      systems: 'Systeme',
      system_assessment: 'System Prüfung',
      supplier: 'Dienstleister',
      incidents: 'Vorfälle',
      review: 'Review/Audit',
      dpa_check: 'AV Check',
      listing: 'Auflistung',
      edit_survey: 'Fragebogen bearbeiten',
      toms: 'TOM',
      ds_report: 'DS Bericht Erstellen',
      translate: 'Übersetzung',
      to_crm: 'CRM Öffnen',
      risk: 'Risiko',
      lenz_tech: 'Lenz-tech',
      website_audit: 'Website Audit',
      start_website_audit: 'Audit erstellen',
      audits_listing: 'Alle Audits',
    },
    task_status: {
      completed: 'Abgeschlossen',
      not_applicable: 'Nicht zutreffend',
      open: 'Offen',
      in_progress: 'In Bearbeitung',
      canceled: 'Annulliert',
      duplicate: 'Duplikat',
      other: 'Anderes',
    },
    data_controller: 'Auftraggeber',
    process_name: 'Name des Prozesses/Verarbeitungstätigkeit',
    stand: 'Stand',
    toms: 'TOM',
    comments: 'Bemerkungen',
    checked_on: 'Geprüft am',
    department: 'Abteilung',
    other_responsible: 'Weitere Verantwortlichkeiten',
    authentication: 'Zugriffe/Rechte',
    deletion: 'Löschkonzept',
    backup: 'Backup',
    remarks: 'Bemerkungen',
    processor: 'Auftragsverarbeiter',
    place: 'Sitz der empfangenden Stelle',
    responsible_units: 'Verantwortliche Organisationeinheit',
    contract_w_date: 'Vertrag - gültig bis',
    checked: 'Prüfung stattgefunden',
    subcontractor: 'Unterauftragnehmer vorhanden',
    subcontractor_checked: 'Unterauftragnehmer genehmigt',
    how: 'Wie werden die pbD verarbeitet?',
    informer: 'Wer übernimmt die Betroffenenrechte?',
    deleter: 'Wer stellt die Löschung sicher?',
    responser: 'Wer übernimmt die Meldung von Datenpannen?',
    all_entries: 'Alle Einträge',
    relevant_entries: 'relevante Einträge',
    irrelevant_entries: 'nicht relevante Einträge',
    old_number: 'alte Nummer',
    new_number: 'neue Nummer',
    ai_number: 'interne Nummer',
    questionnaire: 'Fragenkatalog',
    gdpr_requirement: 'Anforderung aus DSGVO',
    ai_requirement: 'Anforderung aus KI-Verordnung',
    actual_status: 'IST-Stand',
    required_field: 'Pflichtfeld',
    communicated_by: 'mitgeteilt von',
    last_status: 'Letzter Iststand',
    documents: 'Dokumenten',
    help_text: 'Unterstützung zur Erklärung',
    gdpr_reference: 'DSGVO Referenz',
    text_block: 'Textbaustein',
    template_link: 'Link zur Vorlagen',
    yes: 'Ja',
    no: 'Nein',
    others: 'Sonstiges',
    create_task: 'Maßnahme erstellen',
    save: 'speichern',
    close: 'schließen',
    canceled: 'abbrechen',
    save_success_msg: 'ist erfolgreich gespeichert!',
    display_column: 'Spalte anzeigen',
    client_overview: 'Mandant Übersicht',
    with_percentage: 'mit Prozentangaben',
    finished: 'Erledigt',
    in_progress: 'In Bearbeitung',
    no_entry: 'Kein Eintrag',
    task_in_the_year: 'Aufgabe im Jahr',
    topics: 'Themen',
    added: 'Datum',
    origin: 'Herkunft',
    section: 'Abschnitt/Zeile',
    deadline: 'umzusetzen bis / Ziel',
    steps: 'Schritte',
    responsible_person: 'Liegt bei',
    new_task: 'Neue Maßnahme',
    all: 'Alle',
    entries: 'Einträge',
    open_tasks: 'offene Maßnahmen',
    processing_tasks: 'Maßnahmen in Bearbeitung',
    completed_tasks: 'abegeschlossene Maßnahmen',
    listing: 'Auflistung',
    calendar_view: 'Kalendar Ansicht',
    ds_report_info: 'Bericht Informationen',
    time_period: 'Zeitraum',
    authors: 'Autoren',
    template: 'Vorlage',
    addressed_to: 'adressiert an',
    management: 'Geschäftsführung',
    executive_board: 'Vorstand',
    reporting_year: 'Bericht Jahr',
    generate: 'Erstellen',
    ds_report: 'Datenschutz Bericht',
    creation_date: 'Erstellungsdatum',
    incident_acknowledgement: 'Datum und Zeit der Kenntnisnahme',
    reporting_party: 'Meldender / Wer hat die Panne festgestellt',
    incident_description: 'Beschreibung des Sicherheitsvorfalls / Datenpanne',
    incident_consequences: 'Mögliche Konsequenzen für die Betroffenen',
    authority_notification: 'Meldung an die Aufsichtsbehörde',
    authority_notified: 'An die Aufsichtsbehörde gemeldet',
    not_authority_notified: 'Nicht an dieAufsichtsbehörde gemeldet',
    notification_date: 'Meldung an die Aufsichtsbehörde am',
    data_subject_information: 'Information der Betroffenen',
    data_subject_informed: 'Betroffenen informiert',
    data_subject_not_informed: 'Betroffenen wurde nicht informiert',
    data_subject_informed_how: 'Information der Betroffenen am sowie Meldeweg',
    incident_action_plan: 'Abgeleitete Maßnahmen / Durchgeführte Aktionen',
    process_controller: 'Prozess-Verantwortlicher',
    report: 'Bericht',
    start_date: 'Start Datum',
    end_date: 'End Datum',
    report_date: 'Bericht Datum',
    gap_status_entry: 'Iststand eintragen',
    new: 'neue',
    task: 'Maßnahme',
    priority: 'Priorität',
    created_on: 'Erstellt am',
    status: 'Status',
    complete_missing_fields: 'Bitte fehlende Felder vervollständigen!',
    saved_successfully: 'ist erfolgreich gespeichert!',
    deleted_successfully: 'ist erfolgreich gelöscht!',
    gap_question: 'GAP Frage',
    used: 'Verwendet',
    contract: 'Vertrag',
    chargeable: 'Abrechenbar',
    amount: 'Betrag',
    staff: 'Mitarbeiter',
    effort: 'Aufwand',
    confirm_delete_step: 'Sicher, dass dieser Schritt gelöscht wird?',
    confirm_delete_work: 'Sicher, dass dieser Aufwand gelöscht wird?',
    confirm_effort_to_task: 'Sollte Aufwand für die abgeschlossene Maßnahme erstellt werden?',
    confirm_deadline_to_today: 'Sollte das Ziel Datum auf heute gesetzt werden?',
    edit: 'editieren',
    show_more: 'mehr anzeigen',
    cancel: 'Abbrechen',
    abbreviations: 'Abkürzungen',
    switch_client: 'Mandant wechseln',
    general: 'Allgemein',
    data_subject: 'Betroffene Personen',
    collected_pd: 'erfasst pb. Daten',
    other_properties: 'Andere Eigenschaften',
    controller: 'Verantwortlicher',
    av_audit_completed: 'AV Prüfung stattgefunden',
    subcontractors_exist: 'Unterauftragnehmer vorhanden',
    short_description: 'Kurzbeschreibung',
    responsible_department: 'Verantwortliche Abteilung',
    purpose: 'Zweck',
    receiving_party: 'Sitz der empfangenden Stelle',
    type_of_data: 'Art von Daten',
    audit_report: 'Prüfbericht',
    ds_assessment: 'Datenschutzrechtliche Bewertung',
    valid_days: 'Gültigkeitsdauer',
    valid_date: 'Gültigkeitsdatum',
    days: 'Tage',
    dpo_assessment: 'Abschließende Bewertung durch den DSB',
    assessed_by: 'geprüft von',
    dpo_assessment_template: '<p class="ql-align-justify"><span style="background-color: yellow;">Die Grundsätze der Datenschutzgrundverordnung sind eingehalten</span></p><p class="ql-align-justify"><span style="background-color: yellow;">-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Organisation von Datenschutz im Unternehmen: Datenschutzmanagement eingeführt (Compliance einschließlich verschiedener Richtlinien).</span></p><p class="ql-align-justify"><span style="background-color: yellow;">-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Zweck, Rechtsgrundlage für die konkrete Verarbeitungstätigkeit: Definiert und anwendbar. </span></p><p class="ql-align-justify"><span style="background-color: yellow;">-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Technische und organisatorische Maßnahmen bezogen auf die Verarbeitung: Eingeführt und umgesetzt. </span></p><p class="ql-align-justify"><span style="background-color: yellow;">-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Sensibilisierungsmaßnahmen für Personen, welche die Daten verarbeiten: Auf einer regelmäßigen Basis durchgeführt. </span></p><p class="ql-align-justify"><span style="background-color: yellow;">-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Datenübertragungsvertrag (einschließlich Standardvertragsklauseln: Abgeschlossen </span></p><p class="ql-align-justify"><span style="background-color: yellow;">-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Rechte- und Rollenkonzept zur Einsicht auf die Daten in der Verarbeitungstätigkeit: Notwendige Daten aufgrund eines Need-To-Know-Prinzips eingeführt.</span></p><p class="ql-align-justify"><span style="background-color: yellow;">-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Datenminimierung: Nur notwendige Datenfelder (Zweck) vorhanden. </span></p><p class="ql-align-justify"><span style="background-color: yellow;">-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Analyse oder Profilbildung: Nur anonyme Daten, keine personenspezifischen Auswertungen.</span></p><p class="ql-align-justify"><span style="background-color: yellow;">-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Rechte der betroffenen Personen: Getroffen, einschließlich Informationen der betroffenen Personen, bevor die Daten verarbeitet werden. </span></p><p class="ql-align-justify"><span style="background-color: yellow;">-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Löschkonzept: vorhanden, </span></p><p class="ql-align-justify"><span style="background-color: yellow;">-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Risikobewertung als sehr gering eingeschätzt. </span></p><p class="ql-align-justify"><span style="background-color: yellow;">Basierend auf den Informationen (in dieser Systemprüfung zusammengestellt) und den bereitgestellten Unterlagen (XXXX) folgt die Verarbeitung der personenbezogenen Daten den in der DSGVO definierten Grundsätzen für die Verarbeitung personenbezogener Daten. </span></p><p class="ql-align-justify"><span style="background-color: yellow;">Daher kann ich den Einsatz von XXX freigeben. </span></p><p><br></p>',
    language: 'Sprache',
    german: 'Deutsch',
    english: 'Englisch',
    greeting: 'Anrede',
    mr: 'Herr',
    ms: 'Frau',
    hello: 'kein/divers',
    recipient: 'Empfänger',
    duplicate: 'Duplikat',
    approved: 'freigegeben',
    simple_risk_analysis: 'Kurzbewertung Risiko',
    gap_entry: 'GAP Eintragung',
    todo_entry: 'Maßnahme erstellen',
    filled_by: 'ausgefüllt von',
    audited_by: 'geprüft von',
    password: 'Passwort',
    chat_history: 'Chat Verlauf',
    new_chat: 'Neues Gespräch',
    you: 'Du',
    today: 'Heute',
    create_system: 'System erstellen nach der Freigabe',
    ki_used: 'Einsatz von KI',
    dsfa_required: 'DSFA erforderlich',
    ki_not_checked: 'KI im Einsatz, nicht geprüft',
    ki_checked: 'KI im Einsatz, und geprüft',
    released: 'Freigegeben',
    processing: 'In Bearbeitung',
    na: 'NV',
    not_used: 'nicht im Einsatz',
    ai: 'KI',
    mandant_name: 'Mandant',
    created_at: 'Erstellt am',
    auditor_name: 'Prüfer',
    full_report: 'Voll Bericht',
    ai_report: 'KI Bericht',
    dsfa_report: 'DSFA Bericht',
    todo_list: 'Maßnahmenplan',
  },
};

const i18n = new VueI18n({
  locale: 'de',
  fallbackLocale: 'de',
  messages
});

export default i18n;
